// TODO 取得したダウンロード一覧の型
export interface DownloadProduct {
  id: string;
  name: string;
  version: string;
  libVer: string;
  releaseDate: string;
  fid: string;
  downloadId: string;
  groupId: string;
  groupName: string;
  groupOrder: number;
}

export type InitializeState =
  | "Initializing"
  | "Initialized"
  | "initializeError";

export type ExcuteState = "Excuting" | "Excuted" | "ExcuteError";

export enum ExecuteSaveHistoryState {
  Executing = "Executing",
  Executed = "Executed",
  ExecuteError = "ExecuteError",
}

export const DownloadHistoryParam =  {
  PRODUCT_ID : "product_id",
  PRODUCT_NAME : "product_name",
  SAVE_EXIST_DOWNLOAD : "saveDownloadHistory",
}